
import {ReportViewer} from '@parantion/components'

export default {
  components: {ReportViewer},
  computed: {
    template () {
      return this.$store.state.parantion.template.content
    }
  },

  methods: {
    showWarningModal () {
      // First check if user has saved and if there are any unsaved changes!
      this.hide()
    },

    async show () {
      await this.$store.dispatch('parantion/data/resetBeforeNewData')
      this.$refs.reportViewerModal.show()
      // const vars = await this.$store.dispatch('parantion/data/getVarsFromTemplate', {templateHash: this.$store.state.parantion.template.templateId})
      // await this.$store.dispatch('parantion/data/getFormBulkData', {vars: vars, formHash: this.$store.state.survey.activeSurvey.hash})
    },

    hide () {
      this.$emit('hide')
      this.$refs.reportViewerModal.hide()
    }
  }
}
